module.exports = __webpack_public_path__ + "img/item1.e894ba59.png";